<template>
  <div>
    <!-- 荣誉资质 -->
    <div class="Honor">
      <div class="center_box">
        <div class="second_list">
          <div
            :class="activeIndex === index ? 'second_item1' : 'second_item'"
            v-for="(item, index) in secondArr"
            :key="index"
            @click="select(item, index)"
          >
            {{ item.secondName }}
          </div>
        </div>
        <div class="swiper_box">
          <div
            class="honor_prev"
            @mouseenter="prev_Enter"
            @mouseleave="prev_Leave"
          >
            <img
              class="img_cover"
              src="../../assets/indexImg/blue_prev_img.png"
              v-if="prevFlag"
              alt=""
            />
            <img
              class="img_cover"
              src="../../assets/indexImg/transparent_prev_img.png"
              alt=""
              v-else
            />
          </div>
          <div class="center_swiper_box">
            <swiper :options="swiperOptionHonor" ref="mySwiper">
              <swiper-slide
                v-for="(item, index) in honorArr"
                :key="index"
                style="display: flex; justify-content: center"
              >
                <div
                  class="honor_item"
                  @mouseenter="changeImgE(index)"
                  @mouseleave="changeImgL"
                  @click="prev_image(item)"
                >
                  <div class="item_center">
                    <div class="preview_img">
                      <img
                        v-if="upflag == index"
                        class="img_cover"
                        src="../../assets/indexImg/preview_img_blue.png"
                        alt=""
                      /><img
                        class="img_cover"
                        v-else
                        src="../../assets/indexImg/preview_img_white.png"
                        alt=""
                      />
                    </div>
                    <div class="img_list">
                      <img :src="item.image" alt="" />
                    </div>
                    <div class="name_box">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div
            class="honor_next"
            @mouseenter="next_Enter"
            @mouseleave="next_Leave"
          >
            <img
              class="img_cover"
              src="../../assets/indexImg/blue_next_img.png"
              v-if="nextFlag"
              alt=""
            />
            <img
              class="img_cover"
              src="../../assets/indexImg/transparent_next_img.png"
              alt=""
              v-else
            />
          </div>
        </div>
      </div>
      <div
        class="honor_preview_box"
        v-if="previewImagePath !== ''"
        @click="colsePreView"
      >
        <div class="preview_center_box" @click="colsePreView">
          <img :src="previewImagePath" class="img_contain preview_img" alt="" />
          <div class="img_name">{{ preViewImageName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHonor } from "../../http/api";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      swiperOptionHonor: {
        slidesPerView: 4,
        spaceBetween: 38,
        navigation: {
          nextEl: ".honor_next",
          prevEl: ".honor_prev",
        },
      },
      prevFlag: false,
      nextFlag: false,
      secondArr: [
        {
          secondName: "公司荣誉",
        },
        {
          secondName: "仟领地板资质",
        },
        {
          secondName: "天原管道资质",
        },
      ],
      activeIndex: 0,
      honorArr: [
        {
          img: require("../../assets/components_img/temporary/baout_honor1.png"),
          name: "四川质量奖提名奖",
        },
        {
          img: require("../../assets/components_img/temporary/baout_honor2.png"),
          name: "高新技术企业",
        },
        {
          img: require("../../assets/components_img/temporary/baout_honor3.png"),
          name: "高新技术企业",
        },
        {
          img: require("../../assets/components_img/temporary/baout_honor4.png"),
          name: "高新技术企业",
        },
        {
          img: require("../../assets/components_img/temporary/baout_honor1.png"),
          name: "高新技术企业",
        },
      ],
      upflag: -1,
      previewImagePath: "",
      preViewImageName: "",
    };
  },
  methods: {
    getdata(type) {
      getHonor({ type: type }).then((res) => {
        // if(res.status === 'SUCCESS'){
        // console.log(res)
        this.honorArr = res.data;
        // }
      });
    },
    changeImgE(index) {
      this.upflag = index;
    },
    changeImgL() {
      this.upflag = -1;
    },
    select(item, index) {
      //   console.log(item,index)
      this.activeIndex = index;
      this.getdata(index + 1);
    },
    prev_Enter() {
      this.prevFlag = true;
    },
    prev_Leave() {
      this.prevFlag = false;
    },
    next_Enter() {
      this.nextFlag = true;
    },
    next_Leave() {
      this.nextFlag = false;
    },
    prev_image(item) {
      this.previewImagePath = item.image;
      this.preViewImageName = item.name;
    },
    colsePreView() {
      this.previewImagePath = "";
      this.preViewImageName = "";
    },
  },
  mounted() {
    this.getdata(this.activeIndex + 1);
  },
};
</script>

<style scoped lang='scss'>
.Honor {
  width: 100%;
  // height: 528px;
  height: 52.8vh;
  // margin-top: 60px;
  margin-top: 6vh;
  .center_box {
    // width: 1694px;
    // width: 87.70vw;
    width: 86.7vw;
    height: 100%;
    margin: 0 auto;
    .second_list {
      // height: 40px;
      height: 4vh;
      width: 520px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .second_item {
        width: 120px;
        height: 100%;
        border: 1px solid #ffffff;
        border-radius: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        // line-height: 40px;
        line-height: 4vh;
        color: #ffffff;
        text-align: center;
        transition: all 0.5s;
        cursor: url("../../assets/cursor.png"), none;
      }
      .second_item1 {
        width: 120px;
        height: 100%;
        border: 1px solid #0fffff;
        border-radius: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        // line-height: 40px;
        line-height: 4vh;
        color: #0fffff;
        text-align: center;
        transition: all 0.5s;
        cursor: url("../../assets/cursor.png"), none;
      }
      .second_item:hover {
        color: #0fffff;
        border: 1px solid #0fffff;
        transition: all 0.5s;
      }
    }
    .swiper_box {
      width: 100%;
      // height: 438px;
      height: 43.8vh;
      // margin-top: 70px;
      margin-top: 7vh;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .honor_prev {
        width: 92px;
        height: 92px;
      }
      .honor_prev:focus,
      .honor_next:focus {
        outline: none;
      }
      .center_swiper_box {
        width: 1200px;
        height: 100%;

        @media only screen and (min-width: 1900px) {
          width: 1500px;
        }
        .honor_item {
          width: 270px;
          @media only screen and (min-width: 1900px) {
            width: 350px;
          }
          // height: 418px;
          height: 41.8vh;
          border: 1px solid #ffffff;
          transition: all 0.5s;
          // margin-top: 20px;
          margin-top: 2vh;
          display: flex;
          justify-content: center;
          .item_center {
            width: 230px;
            @media only screen and (min-width: 1900px) {
              width: 280px;
            }
            // height: 358px;
            height: 35.8vh;
            // margin-top: 40px;
            margin-top: 4vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .preview_img {
              width: 22px;
              height: 22px;
              position: absolute;
              // bottom: 49px;
              bottom: 4.9vh;
              right: 0;
            }
            .img_list {
              width: 190px;
                                                @media only screen and (min-width: 1900px){
          width: 260px;
}
         
              // height: 269px;
              height: 26.9vh;
              display: table-cell;
              vertical-align: middle;
              text-align: center;
              // line-height: 269px;
              line-height: 26.9vh;
            }

            .img_list > img {
              width: auto;
              height: auto;
              max-width: 100%;
              max-height: 100%;
              object-fit: cover;
              position: relative;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
            }
            .name_box {
              // height: 40px;
              height: 4vh;
              width: 100%;
              border-top: 1px solid #ffffff;
              position: absolute;
              bottom: 0;
              font-size: 22px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              // line-height: 46px;
              line-height: 4.6vh;
              color: #ffffff;
            }
          }
        }
        .honor_item:hover {
          border: 1px solid #0fffff;
          transform: translateY(-10px);
          transition: all 0.5s;
          .name_box {
            border-top: 1px solid #0fffff;
            color: #0fffff;
            transition: all 0.5s;
          }
        }
      }
      .honor_next {
        width: 92px;
        height: 92px;
      }
    }
  }
  .honor_preview_box {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(26, 26, 26, 0.8);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    .preview_center_box {
      // width: 472px;
      width: 1400px;
      // height: 580px;
      // height: 58vh;
      height: 800px;
      position: relative;
      .preview_img {
        position: absolute;
        bottom: 0;
      }
      .img_name {
        position: absolute;
        bottom: 0;
        width: 100%;
        // height: 60px;
        height: 6vh;
        background: rgba(26, 26, 26, 0.6);
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        // line-height: 60px;
        line-height: 6vh;
        color: #ffffff;
        text-align: center;
      }
    }
  }
}
</style>